// extracted by mini-css-extract-plugin
export var container = "styles-module--container--gy2-5";
export var wrapper = "styles-module--wrapper--ywCiF";
export var block = "styles-module--block--zZ6nV";
export var numberContainer = "styles-module--numberContainer--o+ngd";
export var number = "styles-module--number--MSGBt";
export var positive = "styles-module--positive--3GVQD";
export var negative = "styles-module--negative--AjZSa";
export var arrowDown = "styles-module--arrowDown--m4n3E";
export var description = "styles-module--description--mY-PU";